import { MessageAttachmentInfo } from "../../../containers/centralView/communicationView/messageView/types/readMessageViewProps"

export type AttachFileProps = {
    info: MessageAttachmentInfo,
    mode: AttachFileMode,
    onClick: (info: MessageAttachmentInfo) => void
}

export enum AttachFileMode {
    Download = 1,
    Add = 2
}